/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import {
    Form,
    Input,
    InputNumber,
    Switch,
    Button
} from 'antd';

const CustomizedForm = Form.create({
    name: 'signal_form',
    onFieldsChange(props, changedFields) {
      props.onChange(changedFields);
    },
    mapPropsToFields(props) {
      return {
        Id: Form.createFormField({
            ...props.Id,
            value: props.Id?.value,
        }),
        SsName: Form.createFormField({
            ...props.SsName,
            value: props.SsName?.value,
        }),
        RpcAddr: Form.createFormField({
            ...props.RpcAddr,
            value: props.RpcAddr?.value,
        }),
        RpcPort: Form.createFormField({
            ...props.RpcPort,
            value: props.RpcPort?.value,
        }),
        EslAddr: Form.createFormField({
            ...props.EslAddr,
            value: props.EslAddr?.value,
        }),
        EslPort: Form.createFormField({
            ...props.EslPort,
            value: props.EslPort?.value,
        }),
        LocalAddr: Form.createFormField({
            ...props.LocalAddr,
            value: props.LocalAddr?.value,
        }),
        InternalSignalPort: Form.createFormField({
            ...props.InternalSignalPort,
            value: props.InternalSignalPort?.value,
        }),
        PublicAddr: Form.createFormField({
            ...props.PublicAddr,
            value: props.PublicAddr?.value,
        }),
        ExternalSignalPort: Form.createFormField({
            ...props.ExternalSignalPort,
            value: props.ExternalSignalPort?.value,
        }),
        MaxCall: Form.createFormField({
            ...props.MaxCall,
            value: props.MaxCall?.value,
        }),
        Remark: Form.createFormField({
            ...props.Remark,
            value: props.Remark?.value,
        }),
      };
    },
  })(props => {
    const { getFieldDecorator } = props.form;
    const formItemLayout = {
        labelCol: {
            xs: { span: 4 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 20 },
            sm: { span: 20 },
        },
    };
    
    return (
        <Form>
            <Form.Item label="名称">
                {getFieldDecorator('SsName', {
                    initialValue: '信令服务器_',
                    rules: [{ required: true, message: '请输入名称', whitespace: false }],
                })(<Input />)}
            </Form.Item>
            <Form.Item className="form-item-addr" required label="控制信令地址">
                <Form.Item className="form-item-addr-ip">
                    {getFieldDecorator('RpcAddr', {
                        rules: [
                            // { pattern: new RegExp(/^([a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?)$/), message: 'ip地址或域名无效' },
                            { required: true, message: '请输入ip地址或域名' }
                        ],
                    })(<Input placeholder="ip地址或域名" />)}
                </Form.Item>
                <Form.Item className="form-item-addr-port">
                    {getFieldDecorator('RpcPort', {
                        normalize: (value) => value ? parseInt(value) : "",
                        initialValue: '8022',
                        rules: [
                            { pattern: new RegExp(/^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/), message: '端口号无效'},
                            { required: true, message: '端口号无效' }
                        ],
                    })(<Input placeholder="端口号"/>)}
                </Form.Item>
            </Form.Item>
            <Form.Item className="form-item-addr" required label="事件监听地址">
                <Form.Item className="form-item-addr-ip">
                    {getFieldDecorator('EslAddr', {
                        rules: [
                            // { pattern: new RegExp(/^([a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?)$/), message: 'ip地址或域名无效' },
                            { required: true, message: '请输入ip地址或域名' }
                        ],
                    })(<Input placeholder="ip地址或域名" />)}
                </Form.Item>
                <Form.Item className="form-item-addr-port">
                    {getFieldDecorator('EslPort', {
                        normalize: (value) => value ? parseInt(value) : "",
                        initialValue: '8021',
                        rules: [
                            { pattern: new RegExp(/^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/), message: '端口号无效'},
                            { required: true, message: '端口号无效' }
                        ],
                    })(<Input placeholder="端口号"/>)}
                </Form.Item>
            </Form.Item>
            <Form.Item className="form-item-addr" required label="呼叫信令地址(内部)">
                <Form.Item className="form-item-addr-ip">
                    {getFieldDecorator('LocalAddr', {
                        rules: [
                            // { pattern: new RegExp(/^([a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?)$/), message: 'ip地址或域名无效'},
                            { required: true, message: '请输入ip地址或域名'}
                        ],
                    })(<Input placeholder="ip地址或域名"/>)}
                </Form.Item>
                <Form.Item className="form-item-addr-port">
                    {getFieldDecorator('InternalSignalPort', {
                        normalize: (value) => value ? parseInt(value) : "",
                        initialValue: '6560',
                        rules: [
                            { pattern: new RegExp(/^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/), message: '端口号无效'},
                            { required: true, message: '端口号无效' }
                        ],
                    })(<Input placeholder="端口号"/>)}
                </Form.Item>
            </Form.Item>
            <Form.Item className="form-item-addr" required label="呼叫信令地址(外部)">
                <Form.Item className="form-item-addr-ip">
                    {getFieldDecorator('PublicAddr', {
                        rules: [
                            // { pattern: new RegExp(/^([a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?)$/), message: 'ip地址或域名无效' },
                            { required: true, message: '请输入ip地址或域名' }
                        ],
                    })(<Input placeholder="ip地址或域名" />)}
                </Form.Item>
                <Form.Item
                    className="form-item-addr-port">
                    {getFieldDecorator('ExternalSignalPort', {
                        normalize: (value) => value ? parseInt(value) : "",
                        initialValue: '6560',
                        rules: [
                            { pattern: new RegExp(/^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/), message: '端口号无效'},
                            { required: true, message: '端口号无效' }
                        ],
                    })(<Input placeholder="端口号"/>)}
                </Form.Item>
            </Form.Item>
            <Form.Item label="总容量(方)">
                {getFieldDecorator('MaxCall', {
                    normalize: (value) => value ? parseInt(value) : "",
                    initialValue: '0',
                })(<Input placeholder="0代表不限制"/>)}
            </Form.Item>
            <Form.Item label="备注">
                {getFieldDecorator('Remark')(<Input.TextArea rows={3}/>)}
            </Form.Item>
        </Form>
    );
  });

class OSignalForm extends Component {
    render() {
        const { fields, onChange } = this.props;
        return (
            <div>
                <CustomizedForm {...fields} onChange={onChange}/>
            </div>
        );
    }
}

let SignalForm = Form.create({ name: 'register' })(OSignalForm);

export { SignalForm }